export const isEmptyHTML = (html: string) => {
  const fragment = document.createDocumentFragment();
  const div = document.createElement("div");
  div.innerHTML = html;
  fragment.append(div);

  return fragment.textContent?.trim().length === 0;
};
